<template>
  <v-container fluid grid-list-md>
    <v-layout wrap>
      <v-flex xs12>
        <h1>ЖКУ. Реестры</h1>
      </v-flex>
      <v-flex xs12 sm12 class="text-xs-right">
        <v-dialog v-model="dialog">
          <v-tabs>
            <v-tab href="#tab-1">
              Основные данные
            </v-tab>
            <v-tab-item
                    :value="'tab-1'">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }} {{editedFile.id}}</span>
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm8>
                        <v-text-field
                                v-if="editedFile.id == null"
                                v-model="filename"
                                label="Выберете файл"
                                type="text"
                                :error-messages="requiredErrors('file')"
                                @blur="$v.editedFile.file.$touch()"
                                readonly
                                required
                        >
                        </v-text-field>
                        <div
                                v-if="editedFile.id !== null"
                        >
                          {{editedFile.filename}}
                          <v-btn
                                  icon
                                  color="indigo"

                                  @click.native="downloadFile({urlFile: editedFile.file_path,
                                                                      filename: editedFile.filename,
                                                                      mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                                                                      })"
                          >
                            <v-icon>mdi-cloud-download</v-icon>
                          </v-btn>
                          <v-progress-circular
                                  class="ml-3"
                                  indeterminate
                                  color="primary"
                                  v-if="listLoading.includes('downloadFile_' + editedFile.file_path)"
                          ></v-progress-circular>
                        </div>

                      </v-flex>

                      <v-flex xs2 sm2>
                        <upload-btn
                                v-if="editedFile.id == null"
                                this.showIcon = false
                                icon
                                @file-update="fileChanged"
                                flat
                                color=""
                                accept=".xls, .xlsx, .dbf, .zip"
                        >
                          <template  slot="icon">
                            <v-icon>mdi-paperclip</v-icon>
                          </template>
                        </upload-btn>
                      </v-flex>

                      <v-flex xs12 sm8>
                        <v-select
                                v-if="editedFile.id == null"
                                v-model="editedFile.ogrn"
                                :items="dependentDepartments"
                                item-text="name_short"
                                item-value="ogrn"
                                label="Организация"
                                required
                                :error-messages="requiredErrors('ogrn')"
                                @blur="$v.editedFile.ogrn.$touch()"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm8>
                        <v-text-field
                                v-if="editedFile.id !== null"
                                v-model="(getDependentDepartments (editedFile.ogrn)).name_short"
                                label="Организация"
                                readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm8>
                        <v-text-field
                                v-model.trim="editedFile.note"
                                label="Комментарий"
                                :readonly="editedFile.id !== null"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm8>
                        <v-text-field
                                v-if="editedFile.id !== null"
                                v-model="(getProcessStatuses (editedFile.status)).name"
                                label="Статус"
                                readonly></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm8>
                        <v-text-field
                                v-if="editedFile.id !== null"
                                v-model="(getFileType (editedFile.type)).name"
                                label="Тип"
                                readonly></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm8>
                        <div
                                v-if="editedFile.protocol_path"
                        >
                          Протокол ошибок
                          <v-btn
                                  icon
                                  color="indigo"
                                  @click.native="downloadFile({urlFile: editedFile.protocol_path,
                                                                      filename: 'Протокол ошибок.txt',
                                                                      mime: 'text/plain'
                                                                      })"
                          >
                            <v-icon>mdi-alert-octagon</v-icon>
                          </v-btn>
                          <v-progress-circular
                                  class="ml-3"
                                  indeterminate
                                  color="primary"
                                  v-if="listLoading.includes('downloadFile_' + editedFile.protocol_path)"
                          ></v-progress-circular>
                        </div>
                      </v-flex>
                      <v-flex xs12 sm8>
                        <div
                                v-if="editedFile.id == null"
                                class="text-xs-left"
                        >
                          <p><b>Примечание:</b> Файлы больших размеров архивируйте в формате zip.</p>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click.native="close">Отменить</v-btn>
                  <v-btn
                          v-if="editedFile.id == null"
                          @click.native="save">Сохранить</v-btn>
                  <v-btn
                          v-if="(editedFile.id !== null) && (getProcessStatuses(editedFile.status).abbr === 'downloaded')"
                          @click.native="del">Удалить</v-btn>
                </v-card-actions>
              </v-card>
            </v-tab-item>
            <v-tab href="#tab-2">
              Системные данные
            </v-tab>
            <v-tab-item
                    :value="'tab-2'">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }} {{editedFile.id}}</span>
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <table>
                          <tr>
                            <th>Код</th>
                            <td>{{editedFile.id}}</td>
                          </tr>
                          <tr>
                            <th>Период</th>
                            <td>{{ computedDateFormattedMomentjs }}</td>
                          </tr>
                          <tr>
                            <th>Пользователь</th>
                            <td>{{editedFile.full_name_user}}</td>
                          </tr>
                          <tr>
                            <th>Дата создания</th>
                            <td>{{ editedFile.create_date|date_time }}</td>
                          </tr>

                        </table>
                      </v-flex>

                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click.native="close">Отменить</v-btn>
                  <v-btn
                          v-if="editedFile.id == null"
                          @click.native="save">Сохранить</v-btn>
                  <v-btn
                          v-if="(editedFile.id !== null) && (getProcessStatuses(editedFile.status).abbr === 'downloaded')"
                          @click.native="del">Удалить</v-btn>
                </v-card-actions>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-dialog>
      </v-flex>
      <v-flex xs12 sm4>
        <v-menu
                ref="menuFilter"
                v-model="menuFilter"
                :close-on-content-click="false"
                :return-value.sync="period"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
                    :value="computedDateFormattedMomentjs"
                    label="Период"
                    prepend-icon="mdi-calendar-month"
                    readonly
                    v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
                  v-model="period"
                  type="month"
                  no-title
                  scrollable
                  @input="savePeriod"
          >
          </v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 sm6>
      </v-flex>
      <v-flex xs12 sm2>
        <v-progress-circular
          class="ml-3"
          indeterminate
          color="primary"
          :size="70"
          :width="9"
          v-if="listLoading.findIndex(function(el) {return el.indexOf('insertFile') > -1}) > -1"
        >
          <p>
            Происходит загрузка реестра
          </p>

        </v-progress-circular>
      </v-flex>

        <v-flex xs12 sm12 md12>
          <v-tabs>
            <v-tab  href="#tab-1">
              Импорт
            </v-tab>
            <v-tab-item
              :value="'tab-1'">

              <v-data-table
                :items="listFiles.results"
                :server-items-length="listFiles.last_page"
                :loading="listLoading.includes('fetchListFiles')"
                hide-default-footer
                v-model="listFiles.results"
                no-results-text="Нет отфильтрованных данных"
                class="elevation-1">
                <template v-slot:header>
                  <tr>
                    <th>Код</th>
                    <th>Организация</th>
                    <th>Комментарий</th>
                    <th>Тип</th>
                    <th>Статус</th>
                    <th>Протокол ошибок</th>
                    <th>
                      <v-btn
                              icon
                              class="mr-2"
                              @click="editItem(null)"
                      >
                        <v-icon>mdi-pencil-plus</v-icon>
                      </v-btn>
                    </th>
                  </tr>
                </template>
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr  v-for="item in items" :key="item.id">
                      <td>{{ item.id }}</td>
                      <td>{{ (getDependentDepartments (item.ogrn)).name_short }}</td>
                      <td>{{ item.note }}</td>
                      <td>{{ (getFileType (item.type)).name }}</td>
                      <td>{{ (getProcessStatuses (item.status)).name }}</td>
                      <td class="px-0" style="width: 230px;">
                        <div>
                          <v-btn
                                  icon
                                  color="indigo"
                                  v-if="item.protocol_path"
                                  @click.native="downloadFile({urlFile: item.protocol_path,
                          filename: 'Протокол ошибок.txt',
                          mime: 'text/plain'
                          })"
                          >
                            <v-icon>mdi-alert-octagon</v-icon>
                          </v-btn>
                          <v-progress-circular
                                  class="ml-3"
                                  indeterminate
                                  color="primary"
                                  v-if="listLoading.includes('downloadFile_' + item.protocol_path)"
                          ></v-progress-circular>
                        </div>
                      </td>
                      <td class="mx-0">
                        <v-btn
                                icon
                                class="mr-2"
                                @click="editItem(item)"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn></td>
                    </tr>
                  </tbody>
                </template>
                <template slot="no-data">
                  <v-btn color="primary" @click="initializeListFiles">Reset</v-btn>
                </template>
              </v-data-table>
              <div class="text-xs-center pt-2">
                <v-pagination
                  key="pagination"
                  v-model="pagination.page"
                  :length="listFiles.last_page"
                ></v-pagination>
              </div>
            <!--</v-flex>-->
            </v-tab-item>

          <v-tab href="#tab-2">
            Экспорт
          </v-tab>
          <v-tab-item
            :value="'tab-2'">
        <v-flex xs12 sm12 md12>
          <v-data-table
            :items="exportListFiles.results"
            :server-items-length="exportListFiles.last_page"
            :loading="listLoading.includes('fetchExportListFiles')"
            hide-default-footer
            v-model="exportListFiles.results"
            no-results-text="Нет отфильтрованных данных"
            class="elevation-1">
            <template v-slot:header>
              <tr>
                <th>Код</th>
                <th>Организация</th>
                <th>Файл</th>
                <th>Тип</th>
                <th>Количество записей</th>
              </tr>
            </template>
            <template v-slot:body="{ items }">
              <tbody>
                <tr  v-for="item in items" :key="item.id">
                  <td>{{ item.id }}</td>
                  <td>{{ (getDependentDepartments (item.ogrn)).name_short }}</td>
                  <td>
                    <div>
                      {{item.filename}}
                      <div class="bloc_inline">
                        <v-btn
                                icon
                                color="indigo"
                                @click.native="downloadFile({urlFile: item.file_path,
                                                    filename: item.filename,
                                                    mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                                                    })"
                        >
                          <v-icon>mdi-cloud-download</v-icon>
                        </v-btn>
                        <v-progress-circular
                                class="ml-3"
                                indeterminate
                                color="primary"
                                v-if="listLoading.includes('downloadFile_' + item.file_path)"
                        ></v-progress-circular>
                      </div>
                    </div>

                  </td>
                  <td>{{ (getFileType (item.type)).name }}</td>
                  <td>{{ item.quantity_records }}</td>
                </tr>
              </tbody>

            </template>
            <template slot="no-data">
              <v-btn color="primary" @click="initializeExportListFiles">Reset</v-btn>
            </template>

          </v-data-table>
          <div class="text-xs-center pt-2">
            <v-pagination
              key="paginationExportFiles"
              v-model="paginationExportFiles.page"
              :length="exportListFiles.last_page"></v-pagination>
          </div>
        </v-flex>

          </v-tab-item>
        </v-tabs>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import UploadButton from 'vuetify-upload-button'

export default {
  components: {
    'upload-btn': UploadButton
  },
  data () {
    return {
      dialog: false,
      editedFile: {
        id: null,
        year: null,
        month: null,
        create_date: null,
        time_stamp: null,
        supplier: null,
        provide_repair: null,
        file_path: null,
        file: null,
        ogrn: '',
        note: '',
        status: '',
        type: '',
        protocol_path: null,
        full_name_user: null
      },
      defaultFile: {
        id: null,
        year: null,
        month: null,
        create_date: null,
        time_stamp: null,
        supplier: null,
        provide_repair: null,
        file_path: null,
        file: null,
        ogrn: '',
        note: '',
        status: '',
        type: '',
        protocol_path: null,
        full_name_user: null
      },
      search: '',
      pagination: {
        rowsPerPage: 10,
        sortBy: null,
        totalItems: 0,
        page: 1
      },
      paginationExportFiles: {
        rowsPerPage: 10,
        sortBy: null,
        totalItems: 0,
        page: 1
      },
      period: new Date().toISOString().substr(0, 8) + '01',
      menuFilter: false

    }
  },
  mixins: [validationMixin],
  validations: {
    // name: { required, maxLength: maxLength(10) },
    editedFile: {
      ogrn: { required },
      file: { required }
    }
  },
  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    },
    computedDateFormattedMomentjs () {
      return this.period ? moment(this.period).format('MMMM YYYY') : ''
    },
    periodFirstDay () {
      return this.period ? moment(this.period).format('YYYY-MM') : ''
    },
    listFiles () {
      return this.$store.getters['files/listFiles']
    },
    exportListFiles () {
      return this.$store.getters['files/exportListFiles']
    },
    formTitle () {
      return this.editedFile.id === null ? 'Добавить запись' : 'Запись'
    },
    dependentDepartments () {
      return this.$store.getters['auth/dependentDepartments']
    },
    processStatuses () {
      return this.$store.getters['files/processStatuses']
    },
    fileType () {
      return this.$store.getters['files/fileType']
    },
    filename () {
      let result
      try {
        result = this.editedFile.file.name
      } catch (err) {
        result = ''
      }
      return result
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    pagination: {
      handler () {
        this.initializeListFiles()
      },
      deep: true
    },
    paginationExportFiles: {
      handler () {
        this.initializeExportListFiles()
      },
      deep: true
    }
    // menuFilter (val) {
    //   val && this.$nextTick(() => (this.$refs.picker.activePicker = 'MONTH'))
    // }
  },
  methods: {
    initializeListFiles () {
      this.$store.dispatch('files/fetchListFiles', {
        pageId: this.pagination.page,
        period: this.periodFirstDay })
      this.$store.dispatch('files/fetchExportListFiles', {
        pageId: this.paginationExportFiles.page,
        period: this.periodFirstDay
      })
    },
    initializeExportListFiles () {
      this.$store.dispatch('files/fetchListFiles', {
        pageId: this.pagination.page,
        period: this.periodFirstDay })
      this.$store.dispatch('files/fetchExportListFiles', {
        pageId: this.paginationExportFiles.page,
        period: this.periodFirstDay
      })
    },
    savePeriod (period) {
      console.log('savePeriod', period)
      this.$refs.menuFilter.save(period)
      // this.$refs.picker.activePicker = 'MONTH'
      this.menuFilter = true
      this.pagination.page = 1
      this.paginationExportFiles.page = 1
      this.initializeListFiles()
      this.initializeExportListFiles()
    },
    editItem: function (item) {
      if (item == null) {
        this.editedFile = JSON.parse(JSON.stringify(this.defaultFile))
      } else {
        this.editedFile = JSON.parse(JSON.stringify(item))
      }
      // this.editedFile = Object.assign({}, item)
      // TODO:
      // this.editedFile.index = item.index
      this.dialog = true
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedFile = Object.assign({}, this.defaultFile)
        this.editedFile.file = null
        this.editedFile.note = null
        this.editedFile.ogrn = null
      }, 300)
    },
    save () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if (this.editedFile.id == null) {
          this.editedFile.year = moment(this.period).year()
          this.editedFile.month = Number(moment(this.period).format('MM'))
          this.$store.dispatch('files/insertFile', this.editedFile)
        }
        this.close()
      }
    },
    del () {
      if (this.editedFile.id !== null) {
        this.$store.dispatch('files/deleteFile', this.editedFile)
        this.close()
      }
    },
    requiredErrors (fieldName) {
      const errors = []
      const field = this.$v.editedFile[fieldName]
      if (!field.$dirty) return errors
      if (field.hasOwnProperty('required')) {
        !field.required && errors.push('Обязательное поле')
      }
      return errors
    },
    fileChanged (file) {
      // handle file here. File will be an object.
      // If multiple prop is true, it will return an object array of files.
      this.editedFile.file = file
    },
    getDependentDepartments (ogrn) {
      return this.$store.getters['auth/getDependentDepartments'](ogrn)
    },
    getProcessStatuses (status) {
      return this.$store.getters['files/getProcessStatuses'](status)
    },
    getFileType (statusType) {
      return this.$store.getters['files/getFileType'](statusType)
    },
    downloadFile (link) {
      this.$store.dispatch('common/downloadFile', link)
    }
  },
  created: function () {
    this.$store.dispatch('files/fetchProcessStatuses')
    this.$store.dispatch('files/fetchFileType')
    this.initializeListFiles()
    this.initializeExportListFiles()
  }
}
</script>
<style scoped>
  td, th {
    text-align: left;
    padding: 5px;
  }
  th {
    vertical-align: top
  }
  .bloc_inline
  {
    display:inline-block;
  }
</style>
